<template>
    <div class="bg-light py-5">
        <div class="container">
            <div class="row">
                <div class="col-md-3 text-center">
                    <img src="~/assets/img/happiness-guarantee-badge.png" class="mw-100 h-auto">
                </div>
                <div class="col-md-9 pl-5 d-flex flex-column justify-content-center">
                    <div>
                        <h2 class="mb-1" v-text="$t('happiness-guarantee.heading')" />
                        <h4 v-text="$t('happiness-guarantee.subheading')" />
                        <p class="text-muted" v-html="$t('happiness-guarantee.text')" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>

</style>
